import { render, staticRenderFns } from "./BarsWaveReactive.vue?vue&type=template&id=4ef87406&scoped=true&"
import script from "./BarsWaveReactive.vue?vue&type=script&lang=js&"
export * from "./BarsWaveReactive.vue?vue&type=script&lang=js&"
import style0 from "./BarsWaveReactive.vue?vue&type=style&index=0&id=4ef87406&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef87406",
  null
  
)

export default component.exports